import _ from 'lodash';
import { createSelector } from 'reselect';

import CadminApi        from 'app/apis/company-admin';
import reducerUtils     from 'app/reducers/utils';
import CadminSlx        from 'app/selectors/company-admin/';
import EntitiesSlx      from 'app/selectors/entities';
import ToastAx          from 'app/actions/toast';



/*
 *  Actions
 */

const Types = {
  SET_EMP: 'CADMIN_CATTR_VALS_SET_EMP',
  FETCH: 'CADMIN_CATTR_VALS_FETCH',
  UPDATE_CATTRS: 'CADMIN_CATTR_VALS_UPDATE_CATTRS',
  UPDATE: 'CADMIN_CATTR_VALS_UPDATE',
  CREATE: 'CADMIN_CATTR_VALS_CREATE',
  DELETE: 'CADMIN_CATTR_VALS_DELETE',
};

const Ax = {

  setEmployee: (employeeId) => (dispatch, getState) => {
    dispatch({type: Types.SET_EMP, employeeId});
    dispatch(Ax.fetch());
  },

  fetch: () => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const employeeId = Slx.employeeId(getState());
    const key = `${Math.random()}`;
    const promise = CadminApi.employeesCattrValsFetch(company.id, employeeId);
    return dispatch({type: Types.FETCH, promise, key, employeeId, _entities: ['employee']});
  },

  /**
   *  Updates many cattrs
   */
  updateCattrs: (cattrs, asOf) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const employeeId = Slx.employeeId(getState());
    const promise = CadminApi.employeesCattrsUpdate(company.id, employeeId, cattrs, asOf);
    promise.then(() => {
      dispatch(ToastAx.success('Changes saved.'));
    });
    return dispatch({type: Types.UPDATE_CATTRS, promise, employeeId, _entities: ['employee']});    
  },

  /**
   *  Updates a particular CustomAttributeValue record
   */
  updateCattrValue: (cavId, attrs) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const employeeId = Slx.employeeId(getState());
    const promise = CadminApi.employeesCattrValsUpdate(company.id, employeeId, cavId, attrs);
    promise.then(() => {
      dispatch(ToastAx.success('Entry updated.'));
    });
    return dispatch({type: Types.UPDATE, promise, employeeId, _entities: ['employee']});
  },
  deleteCattrValue: (cavId) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const employeeId = Slx.employeeId(getState());
    const promise = CadminApi.employeesCattrValsDelete(company.id, employeeId, cavId);
    promise.then(() => {
      dispatch(ToastAx.success('Entry deleted.'));
    });
    return dispatch({type: Types.DELETE, promise, employeeId, _entities: ['employee']});
  },
  createCattrValue: (attrs) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const employeeId = Slx.employeeId(getState());
    const promise = CadminApi.employeesCattrValsCreate(company.id, employeeId, attrs);
    promise.then(() => {
      dispatch(ToastAx.success('Entry saved.'));
    });
    return dispatch({type: Types.CREATE, promise, employeeId, _entities: ['employee']});
  },

};



/*
 *  Reducer
 */

const initialState = {
  employeeId: null,
  cattrVals: null,
  fetchKey: null,
  fetchPending: false,
  updateCattrsPending: false,
  updatePending: false,
  deletePending: false,
  createPending: false,
};

const reducer = reducerUtils.createReducer(initialState, {

  [Types.SET_EMP]: (state, action) => {
    const newState = {employeeId: action.employeeId};
    const isChanged = state.employeeId !== action.employeeId;
    if (isChanged) {
      newState.cattrVals = null;
      newState.editCavId = null;
    }
    return {...state, ...newState};
  },

  [`${Types.FETCH}_PENDING`]: (state, action) => {
    return {...state,
      fetchPending: true,
      fetchKey: action.key,
    };
  },
  [`${Types.FETCH}_RESOLVED`]: (state, action) => {
    if (state.fetchKey !== action.key) return state;
    return {...state,
      fetchPending: false,
      cattrVals: action.result.customAttributeValues,
    };
  },
  [`${Types.FETCH}_REJECTED`]: (state, action) => {
    if (state.fetchKey !== action.key) return state;
    return {...state,
      fetchPending: false,
    };
  },

  [`${Types.UPDATE_CATTRS}_PENDING`]: (state, action) => {
    return {...state,
      updateCattrsPending: true,
    };
  },
  [`${Types.UPDATE_CATTRS}_RESOLVED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      updateCattrsPending: false,
      cattrVals: action.result.customAttributeValues,
    };
  },
  [`${Types.UPDATE_CATTRS}_REJECTED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      updateCattrsPending: false,
    };
  },

  [`${Types.UPDATE}_PENDING`]: (state, action) => {
    return {...state,
      updatePending: true,
    };
  },
  [`${Types.UPDATE}_RESOLVED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      updatePending: false,
      cattrVals: action.result.customAttributeValues,
    };
  },
  [`${Types.UPDATE}_REJECTED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      updatePending: false,
    };
  },

  [`${Types.DELETE}_PENDING`]: (state, action) => {
    return {...state,
      deletePending: true,
    };
  },
  [`${Types.DELETE}_RESOLVED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      deletePending: false,
      cattrVals: action.result.customAttributeValues,
    };
  },
  [`${Types.DELETE}_REJECTED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      deletePending: false,
    };
  },

  [`${Types.CREATE}_PENDING`]: (state, action) => {
    return {...state,
      createPending: true,
    };
  },
  [`${Types.CREATE}_RESOLVED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      createPending: false,
      cattrVals: action.result.customAttributeValues,
    };
  },
  [`${Types.CREATE}_REJECTED`]: (state, action) => {
    if (state.employeeId !== action.employeeId) return state;
    return {...state,
      createPending: false,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selEmployeeId          = (state) => state.companyAdmin.cattrVals.employeeId;
  const selFetchPending        = (state) => state.companyAdmin.cattrVals.fetchPending;
  const selCattrVals           = (state) => state.companyAdmin.cattrVals.cattrVals;
  const selUpdateCattrsPending = (state) => state.companyAdmin.cattrVals.updateCattrsPending;
  const selUpdatePending       = (state) => state.companyAdmin.cattrVals.updatePending;
  const selDeletePending       = (state) => state.companyAdmin.cattrVals.deletePending;
  const selCreatePending       = (state) => state.companyAdmin.cattrVals.createPending;

  const selCattrs = createSelector(
    [selEmployeeId, EntitiesSlx.employees],
    (empId, empMap) => {
      const emp = empMap[empId];
      return emp?.cattrs || {};
    }
  );

  const selChangePending = createSelector(
    [selUpdatePending, selDeletePending, selCreatePending, selUpdateCattrsPending],
    (p1, p2, p3, p4) => {
      return !!(p1 || p2 || p3 || p4);
    }
  );

  return {
    employeeId: selEmployeeId,
    fetchPending: selFetchPending,
    cattrs: selCattrs,
    cattrVals: selCattrVals,
    updateCattrsPending: selUpdateCattrsPending,
    updatePending: selUpdatePending,
    deletePending: selDeletePending,
    createPending: selCreatePending,
    changePending: selChangePending,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
